import React, { memo, ReactElement } from "react";
import PayButton from "../PayButton";
import { useEffectOnce } from "@swiggy-private/core-ui";
import { capitalizeFirstLetter } from "@payment-ui/helpers/String";

import styles from "./NoPaymentMethod.v4.scss";

interface NoPaymentMethodProps {
    onClick: VoidFunction;
    onImpression: () => void;
    title: string;
}

const NoPaymentMethod = (props: NoPaymentMethodProps): ReactElement => {
    useEffectOnce(() => {
        props.onImpression();
    });
    return (
        <PayButton onClick={props.onClick}>
            <div className={styles.title}>{capitalizeFirstLetter(props.title)}</div>
        </PayButton>
    );
};

export default memo(NoPaymentMethod);
